import { TextStyle, Dimensions } from "react-native"
import { color, typography } from "@app/theme"

/**
 * All text will start off looking like this.
 */
const BASE: TextStyle = {
  fontFamily: typography.primary,
  color: color.text,
  fontSize: 16
}

/**
 * All the variations of text styling within the app.
 *
 * You want to customize these to whatever you need in your app.
 */
export const presets = {
  /**
   * The default text styles.
   */
  default: BASE,

  /**
   * A bold version of the default text.
   */
  bold: { 
    ...BASE, 
    fontFamily: typography.primaryBold, 
    fontWeight: "bold" 
  } as TextStyle,

  /**
   * headers.
   */
  header: {
    ...BASE,
    fontFamily: typography.primaryBold,
    fontSize: 18,
    fontWeight: "bold",
    color: color.palette.pink5,
    maxWidth: 780,
    marginBottom: 16
  } as TextStyle,

  /**
   * Large headers.
   */
  headerLarge: {
    ...BASE,
    fontFamily: typography.primaryBold,
    fontSize: Dimensions.get("window").width > 768 ? 38 : 24,
    fontWeight: "bold",
    color: color.palette.pink5,
    maxWidth: 780,
    marginBottom: 16
  } as TextStyle,

  /**
   * Field labels that appear on forms above the inputs.
   */
  fieldLabel: { ...BASE, fontSize: 13, color: color.dim } as TextStyle,

  /**
   * A smaller piece of secondary information.
   */
  secondary: { ...BASE, fontSize: 9, color: color.dim } as TextStyle
}

/**
 * A list of preset names.
 */
export type TextPresets = keyof typeof presets
